/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/secret';
import { SECRET } from '@/store/types';
import { finalizeAction } from '@/store/actions';

export interface StoreSecretTopsDetailState {
  type: string;
  tops: api.SecretTopUser[];
}

export default {
  namespaced: true,
  state: {
    type: null,
    tops: null,
  },
  getters: {},
  actions: {
    [SECRET.GET_TOPS]({ state, commit }, { type, action: rawAction }) {
      const action = finalizeAction(rawAction, state.tops && state.type === type);
      if (action) {
        return new Promise((resolve, reject) => {
          api.getTops(type).then((res) => {
            commit(SECRET.GET_TOPS, { data: res.data, type });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [SECRET.GET_TOPS](state, { data, type }) {
      state.tops = data;
      state.type = type;
    },
  },
};
